import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Compare", -1)

import moment, { Moment } from "moment";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { UseDateStore } from "../State/Stores/DateStore";
import { UseComparisonHelper } from "../../Helper/Stateful/UseComparisonHelper";

interface IShortCutsValue {
  start: Moment;
  end: Moment;
}

interface IShortcutsFull {
  key: string;
  label: string;
  value: () => IShortCutsValue;
}


import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
const __default__ = {
  components: {
    VueCtkDateTimePicker,
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());

const {
  comparisonDatesComputed: comparingDatesCompute,
  comparingComputed: comparingCompute,
  datesComputed,
  comparing,
} = UseComparisonHelper();

const rangeValidation = () => {
  if (!datesComputed.value.start) {
    datesComputed.value.start = moment()
      .subtract(1, "day")
      .format("YYYY-MM-DD");
  }

  // If its after max date, take it back to max date
  if (
    datesComputed.value.end &&
    moment(datesComputed.value.end, "YYYY-MM-DD").diff(
      moment(getDateFrom.value, "YYYY-MM-DD"),
      "days"
    ) > 0
  ) {
    datesComputed.value.end = moment(getDateFrom.value)
      .subtract(1, "day")
      .format("YYYY-MM-DD");
  }

  if (datesComputed.value.start && datesComputed.value.end) {
    comparingDatesCompute.value = {
      start: moment(datesComputed.value.start).format("YYYY-MM-DD"),
      end: moment(datesComputed.value.end).format("YYYY-MM-DD"),
    };
  }
};

const validateDatesOnHidden = () => {
  if (!datesComputed.value.end) {
    let end = moment(getDateFrom.value).subtract(1, "day");
    datesComputed.value.end = moment(end).format("YYYY-MM-DD");

    comparingDatesCompute.value = {
      start: moment(datesComputed.value.start).format("YYYY-MM-DD"),
      end: moment(datesComputed.value.end).format("YYYY-MM-DD"),
    };
  }
};

const shortcuts = computed((): IShortcutsFull[] => {
  return [
    {
      key: "previous",
      label: "Previous Period",
      value: () => {
        let to = moment(getDateFrom.value).subtract(1, "day");
        let fromx = to.clone();
        fromx.subtract(
          moment(getDateTo.value).diff(moment(getDateFrom.value), "days"),
          "days"
        );

        return {
          start: fromx,
          end: to,
        };
      },
    },
    {
      key: "year",
      label: "Year on Year",
      value: () => {
        return {
          start: moment(getDateFrom.value).subtract(1, "year"),
          end: moment(getDateTo.value).subtract(1, "year"),
        };
      },
    },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_field = _resolveComponent("o-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_o_field, null, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([{ 'is-primary': _unref(comparing) }, "button"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (comparingCompute.value = !_unref(comparing)))
        }, [
          _createVNode(_component_o_icon, { icon: "compare" }),
          _hoisted_1
        ], 2)
      ]),
      _: 1
    }),
    (_unref(comparing))
      ? (_openBlock(), _createBlock(_component_o_field, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(VueCtkDateTimePicker), {
              range: true,
              modelValue: _unref(comparingDatesCompute),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(comparingDatesCompute) ? (comparingDatesCompute).value = $event : null)),
              label: "Comparison dates",
              formatted: "DD/MM/YYYY",
              format: "YYYY-MM-DD",
              right: true,
              onIsHidden: validateDatesOnHidden,
              onInput: rangeValidation,
              "input-size": "sm",
              maxDate: _unref(getDateFrom),
              noClearButton: true,
              class: "datepicker-minimum-width",
              "first-day-of-week": 1,
              "custom-shortcuts": _unref(shortcuts),
              shortcut: "previous",
              id: "theone"
            }, null, 8, ["modelValue", "maxDate", "custom-shortcuts"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})